import router from '@/router'
import store from '@/store'
import { getButtons } from '@/api/buttonPermisson'

export const permission = {
	inserted(el, binding, vnode) {
		const styleDisplay = el?.style?.display ?? ''
		const { value = {} } = binding
		const { metaId, marks = [] } = value
		const queryMetaId = router?.currentRoute?.meta?.id ?? -1
		const localMetaId = metaId ??
			(queryMetaId !== -1 ? queryMetaId : window.localStorage.getItem('metaId')) ?? -1
		const { permissionButtonMap } = store.getters
		if (permissionButtonMap?.has(Number(localMetaId))) {
			const permissionButtonList = permissionButtonMap?.get(Number(localMetaId)) ?? []
			permissionAuthorityDisplay({ permissionButtonList, marks, el, styleDisplay })
			return
		}
		if (localMetaId != -1) {
			el.style.display = 'none'
			getButtons(localMetaId)
				.then(({ code = 0, data = [] }) => {
					let roles = code === 10000 ? data : []
					if (marks && Array.isArray(marks) && marks.length > 0) {
						const permissionRoles = marks
						const hasPermission = roles.some(role => {
							return permissionRoles.includes(role)
						})
						if (!hasPermission) {
							el.parentNode && el.parentNode.removeChild(el)
						} else {
							el.style.display = styleDisplay
						}
					} else {
						throw new Error(`权限列表中未找到${marks}权限, 请检查当前角色是否分配该权限`)
					}
				})
				.catch(err => {
					console.log(err)
				})
		}
	}
}

/**
 * 权限按钮控制显示
 * @param {Array} permissionButtonList 权限按钮列表
 * @param {Array} marks 权限权限
 * @param {Dom} el 按钮DOM
 * @param {Srting} styleDisplay 按钮Display样式
 * */
const permissionAuthorityDisplay = ({ permissionButtonList = [], marks = [], el, styleDisplay }) => {
	const hasPermission = permissionButtonList.some(role => {
		return marks.includes(role)
	})
	if (!hasPermission) {
		el.parentNode && el.parentNode.removeChild(el)
	} else {
		el.style.display = styleDisplay
	}
}
